import { Facebook, Instagram, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-6">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <p className="text-gray-600 text-sm">
          © {new Date().getFullYear()} Pavan's Badminton Academy.<br></br>
          <div className="bg-white text-black text-xs sm:text-sm text-center py-2 flex items-center justify-center space-x-2 z-50 relative">
          <span>Created by</span>
          <a 
            href="https://www.linkedin.com/in/gowtham-kamalasekar" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex items-center gap-1 font-semibold text-blue-400 hover:text-blue-300 underline transition duration-200"
          >
            <img src="/linkedin_icon.png" alt="LinkedIn" className="w-4 h-4" />
            Gowtham T K
          </a>
        </div>
        </p>
        <div className="flex space-x-6">
          <a href="https://wa.me/+918100376761" target="_blank" rel="noopener noreferrer">
            <MessageCircle className="text-gray-600 hover:text-gray-900" size={20} />
          </a>
          <a href="https://instagram.com/nathanvaithia" target="_blank" rel="noopener noreferrer">
            <Instagram className="text-gray-600 hover:text-gray-900" size={20} />
          </a>
          <a href="https://facebook.com/vaithia.nathan.923" target="_blank" rel="noopener noreferrer">
            <Facebook className="text-gray-600 hover:text-gray-900" size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}
